import ConsultantDTO from '@src/adapters/dto/consultant/ConsultantDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  gmcNumber: string;
}

type Result = ConsultantDTO[];

const options: ApiOptions = {
  method: 'get',
  urlPath: '/consultant-records',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useGetConsultantRecords = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useGetConsultantRecordsLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useGetConsultantRecords;
